var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZ2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.14375,
    y: 4.26265,
    width: 13.9,
    height: 9.68481,
    rx: 1.45,
    stroke: "#2469EF",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9063 3.99653V2.00003C11.9063 1.44775 11.4586 1.00003 10.9063 1.00003H5.28125C4.72897 1.00003 4.28125 1.44775 4.28125 2.00003V3.99653",
    stroke: "#2469EF",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34375 8.52998H6",
    stroke: "#2469EF",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 7.45576L8.09375 9.6042",
    stroke: "#2469EF",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.52998H14.6563",
    stroke: "#2469EF",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZ2);
export default __webpack_public_path__ + "static/media/z2.0c5f68c8b72810d43b509f9c04c22d46.svg";
export { ForwardRef as ReactComponent };